import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchContact, postEmailContact } from '../services';

// Thunk asíncrono para obtener los datos de contacto desde la API
export const fetchContactData = createAsyncThunk(
    'contact/fetchContactData',
    async (countryId = 1, { rejectWithValue }) => {
        try {
            const data = await fetchContact(countryId);
            return data;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// Thunk asíncrono para enviar un email de contacto
export const sendEmailContact = createAsyncThunk(
    'contact/sendEmailContact',
    async (data, { rejectWithValue }) => {
        try {
            const response = await postEmailContact(data.countryId, data.emailData);
            return response;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

const contactSlice = createSlice({
    name: 'contact',
    initialState: {
        data: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchContactData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchContactData.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchContactData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(sendEmailContact.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(sendEmailContact.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(sendEmailContact.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default contactSlice.reducer;
